function getPathSegments(path?: string): string[] {
  const normalized = (path || window.location.pathname).split('?')[0]
  return normalized.replace(/^\/+/, '').split('/').filter(Boolean)
}

/**
 * 解析 page_name：
 * - 末段为纯数字 → 页面 id（如 /ToyBricksView/6833 → 6833）
 * - 固定路由 → 路由名（如 /MidYearAggregation → MidYearAggregation）
 */
export function resolvePageName(path?: string): string {
  const segments = getPathSegments(path)

  if (!segments.length) {
    return '/'
  }

  const last = segments[segments.length - 1]
  if (/^\d+$/.test(last)) {
    return last
  }

  if (segments.length === 1) {
    return segments[0]
  }

  return segments.join('/')
}

export function resolveActionName(path?: string): string {
  const segments = getPathSegments(path)

  if (!segments.length) {
    return '/'
  }

  if (/^\d+$/.test(segments[segments.length - 1]) && segments.length > 1) {
    segments.pop()
  }

  return segments.join('/')
}
